"use strict";

class SwipeView {
	constructor(context) {
		/***********************
		 * POLYFILLS
		 **********************/
		if (!NodeList.prototype.forEach) {
			NodeList.prototype.forEach = Array.prototype.forEach;
		}

		this.context = context;
		this.elements = document.querySelectorAll(
			`[data-swipeview="${this.context}"]`
		);
		this.total = this.elements.length;

		if (this.total === 0) {
			return;
		}

		if (!Element.prototype.scrollTo) {
			Element.prototype.scrollTo = function({ top, left }) {
				console.log(this);
				if (top && !left) {
					this.scrollTop = top;
				} else if (left) {
					this.scrollLeft = left;
				}
			};
		}

		/***********************
		 * STATES
		 **********************/
		this.isOpen = false;
		this.currentIndex = -1;
		this.lastFocusedElement = null;

		/***********************
		 * HELPER CONSTANTS
		 **********************/
		this.constants = {
			classPrefix: "swipeview",
			arrowLeft: 37,
			arrowLUp: 38,
			arrowRight: 39,
			arrowDown: 40,
			escape: 27,
			tab: 9
		};

		/***********************
		 * CREATE STRUCTURE
		 **********************/
		this.container = document.createElement("div");
		this.listwrapper = document.createElement("div");
		this.list = document.createElement("ul");

		/***********************
		 * CREATE CONTROLS
		 **********************/
		this.exitButton = document.createElement("button");
		this.previousButton = document.createElement("button");
		this.nextButton = document.createElement("button");

		/***********************
		 * SET ATTRIBUTES
		 **********************/
		this.container.role = "application";
		this.container.classList = this.constants.classPrefix;
		this.listwrapper.classList.add(
			`${this.constants.classPrefix}__list-wrapper`
		);

		this.list.role = "presentation";
		this.list.style.width = `${this.total * 100}vw`;
		this.list.classList.add(`${this.constants.classPrefix}__list`);
		//this.list.style.width = `${this.total*100}vw`;

		//this.nextButton.id = `${this.context}-next`;
		this.nextButton.type = "button";
		this.nextButton.setAttribute("aria-label", "Další obrázek");
		this.nextButton.classList.add(
			`${this.constants.classPrefix}__button`,
			`-next-button`
		);

		//this.previousButton.id = `${this.context}-previous`;
		this.previousButton.type = "button";
		this.previousButton.setAttribute("aria-label", "Předchozí obrázek");
		this.previousButton.classList.add(
			`${this.constants.classPrefix}__button`,
			`-previous-button`
		);

		//this.exitButton.id = `${this.context}-exit`;
		this.exitButton.type = "button";
		this.exitButton.setAttribute("aria-label", "Zavřít galerii");
		this.exitButton.classList.add(
			`${this.constants.classPrefix}__button`,
			`-exit-button`
		);

		/***********************
		 * POPULATE GALLERY
		 **********************/
		let item, image;

		if (window.IntersectionObserver) {
			this.observer = new IntersectionObserver(entries => {
				entries.forEach(({ isIntersecting, target }) => {
					/**
					 * Obrázek není ve viewportu nebo už je zpracovaný
					 **/
					if (!isIntersecting || target.dataset.processed) return;

					/**
					 * Nastavíme srcset pouze pokud existoval na originálním obrázku, jinak by se načítal prázdný
					 **/
					target.src = target.dataset.src;
					target.classList.add("processed");
					target.dataset.processed = "true";

					if (this.observer.unobserve) {
						this.observer.unobserve(target);
					}
				});
			});
		}

		this.elements.forEach((element, index) => {
			item = document.createElement("li");
			item.classList.add(`${this.constants.classPrefix}__item`);
			item.dataset.index = index;

			image = new Image();
			image.role = "presentation";
			image.alt = element.dataset.name || "";

			if (element.dataset.swipeviewSizes) {
				const sizes = [...element.dataset.swipeviewSizes.split("x")];
				image.width = sizes[0];
				image.height = sizes[1];
			}

			if (window.IntersectionObserver) {
				image.classList.add("lazy-image");

				image.onload = function() {
					console.log("loaded", this.src, this.dataset.src);
					if (this.getAttribute("src") === this.dataset.src) {
						this.classList.add("loaded");
						this.onload = null;
						this.removeAttribute("data-src");
					}
				};

				image.src = `data:image\/svg+xml;charset=utf8,%3Csvg%20width='${image.width}'%20height='${image.height}'%20viewBox='0%200%20${image.width}%20${image.height}'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20%3E%3C/svg%3E`;
				image.dataset.src = element.dataset.swipeviewSource;
				this.observer.observe(image);
			} else {
				image.src = element.dataset.swipeviewSource;
			}

			image.classList.add(`${this.constants.classPrefix}__image`);
			// item.style.backgroundImage = `url(${image.src})`;
			// item.style.backgroundSize = "contain";
			item.insertAdjacentElement("beforeend", image);
			this.list.insertAdjacentElement("beforeend", item);

			element.addEventListener("click", event => {
				event.preventDefault();
				this.show(index, false).open();
			});
		});

		(item = null), (image = null);

		/***********************
		 * CONSTRUCT HTML
		 **********************/
		this.listwrapper.insertAdjacentElement("beforeend", this.list);
		this.container.insertAdjacentElement("beforeend", this.listwrapper);
		this.container.insertAdjacentElement("beforeend", this.previousButton);
		this.container.insertAdjacentElement("beforeend", this.nextButton);
		this.container.insertAdjacentElement("beforeend", this.exitButton);

		document.body.insertAdjacentElement("beforeend", this.container);

		const focusableElements = Array.from(
			this.container.querySelectorAll("button")
		);

		this.firstFocusable = focusableElements.shift();
		this.lastFocusable = focusableElements.pop();

		console.log(this.firstFocusable, this.lastFocusable);

		this.animRef = null;
		this.smoothScrollSupport = window.getComputedStyle(
			this.container
		).scrollBehavior;

		/***********************
		 * SET LISTENERS
		 **********************/
		this.exitButton.addEventListener("click", () => {
			this.close();
		});
		this.nextButton.addEventListener("click", () => {
			this.show(this.currentIndex + 1);
		});
		this.previousButton.addEventListener("click", () => {
			this.show(this.currentIndex - 1);
		});

		// this.container.addEventListener("wheel", this._debounce((event) => {
		// 	if (event.deltaY > 0) {
		// 		console.log("scrolling down");
		// 		this.show(this.currentIndex+1);
		// 	} else if (event.deltaY < 0) {
		// 		console.log("scrolling up");
		// 		this.show(this.currentIndex-1);
		// 	}
		// }, 21));

		let touchStartScrollPosition = null;
		let touchStartFingerPosition = null;
		let touchStartVerticalFingerPosition = null;
		let touchSnapThreshold = null;
		const touchCloseThreshold = 140;
		//let clampedScroll = null;

		this.list.addEventListener("touchstart", event => {
			if (event.touches.length > 1) {
				return;
			}

			event.preventDefault();
			this.list.style.setProperty("--edge-transition", "none");
			console.log(event);
			touchSnapThreshold = this.container.offsetWidth / 4;
			//clampedScroll = this.list.offsetWidth-this.container.offsetWidth;
			touchStartScrollPosition = this.listwrapper.scrollLeft;
			console.log(
				"touchStartScrollPosition set to " + touchStartScrollPosition
			);
			touchStartFingerPosition = event.touches[0].screenX;
			touchStartVerticalFingerPosition = event.touches[0].screenY;
		});

		this.list.addEventListener("touchmove", event => {
			if (touchStartScrollPosition === null) {
				console.log("touchStartScrollPosition not set");
				return;
			}

			const direction =
				event.changedTouches[0].screenX - touchStartFingerPosition;
			//const ratio = direction/clampedScroll*100;

			if (
				(this.currentIndex === 0 && direction > 0) ||
				(this.currentIndex === this.total - 1 && direction < 0)
			) {
				//console.log(ratio);
				//this.list.classList.add("-edge-last");
				const shift = Math.min(Math.max(direction / 2, -50), 50);
				//this.list.style.transform = `translateX(${direction/2}px)`;
				this.list.style.setProperty(
					"--edge-transform",
					`translateX(${shift}px)`
				);
			}

			event.preventDefault();
			//console.log(this.listwrapper.scrollLeft);
			const touchDifference =
				touchStartFingerPosition - event.changedTouches[0].screenX;
			const movement = touchStartScrollPosition + touchDifference;

			this.listwrapper.scrollTo({
				top: 0,
				left: movement,
				behavior: "auto"
			});
		});

		this.list.addEventListener("touchend", event => {
			if (touchStartScrollPosition === null) {
				return;
			}

			//this.list.style.transition = "";
			this.list.style.setProperty(
				"--edge-transition",
				"transform .25s ease-out"
			);
			this.list.style.setProperty("--edge-transform", "translateX(0)");

			event.preventDefault();
			console.log(this.listwrapper.scrollLeft);
			const touchDifference =
				touchStartFingerPosition - event.changedTouches[0].screenX;

			const touchVerticalDifference =
				touchStartVerticalFingerPosition - event.changedTouches[0].screenY;

			if (
				Math.abs(touchVerticalDifference) > touchCloseThreshold &&
				Math.abs(touchDifference) <= touchSnapThreshold
			) {
				this.close();
			}

			// console.log("difference", touchDifference);
			// console.log("threshold", touchSnapThreshold);
			// console.log(Math.abs(touchDifference) > touchSnapThreshold);
			// const touchEndFingerPosition = event.touches[0].screenX;

			if (Math.abs(touchDifference) > touchSnapThreshold) {
				//moved enough to scroll
				if (touchDifference > 0) {
					console.log("swipe right");
					this.show(this.currentIndex + 1);
				} else {
					console.log("swipe left");
					this.show(this.currentIndex - 1);
				}
			} else {
				//snap back to current
				this.show(this.currentIndex);
			}

			touchStartScrollPosition = null;
			touchStartFingerPosition = null;
			touchStartVerticalFingerPosition = null;
			touchSnapThreshold = null;
		});

		window.addEventListener("keydown", ({ keyCode }) => {
			if (this.isOpen) {
				switch (keyCode) {
					case this.constants.escape:
						this.close();
						break;
					case this.constants.arrowRight:
						this.show(this.currentIndex + 1);
						break;
					case this.constants.arrowLeft:
						this.show(this.currentIndex - 1);
						break;
					// case this.constants.tab:
					// 	if (event.shiftKey && document.activeElement.parentNode !== this.container) {
					// 		event.preventDefault();
					// 		console.log(document.activeElement);
					// 		this.lastFocusable.focus();
					// 	} else if (!event.shiftKey && document.activeElement.parentNode !== this.container) {
					// 		event.preventDefault();
					// 		console.log(document.activeElement);
					// 		this.firstFocusable.focus();
					// 	}
					// break;
					default:
						break;
				}
			}
		});

		window.addEventListener("resize", () => {
			if (this.isOpen) {
				this.show(this.currentIndex);
			}
		});

		window.addEventListener("focusin", event => {
			console.log(document.activeElement.parentNode === this.container);
			if (
				this.isOpen &&
				document.activeElement.parentNode !== this.container
			) {
				event.preventDefault();
				console.log(document.activeElement);

				if (!this.nextButton.disabled) {
					this.nextButton.focus();
				}
			}
		});

		this.listwrapper.scrollTo(0, 0);
		this.container.addEventListener("animationend", () => {
			if (!this.isOpen) {
				this.container.style.visibility = "hidden";
			}
		});
	}

	_scroll() {
		const scrollStep = this.container.offsetWidth / 16;
		const desiredPosition = this.container.offsetWidth * this.currentIndex;
		console.log("called scroll");

		if (this.listwrapper.scrollLeft === desiredPosition) {
			cancelAnimationFrame(this.animRef);
			return;
		}

		if (this.listwrapper.scrollLeft > desiredPosition) {
			//moving backwards
			this.listwrapper.scrollLeft =
				this.listwrapper.scrollLeft - scrollStep < desiredPosition
					? desiredPosition
					: this.listwrapper.scrollLeft - scrollStep;
		} else {
			//moving forwards
			this.listwrapper.scrollLeft =
				this.listwrapper.scrollLeft + scrollStep > desiredPosition
					? desiredPosition
					: this.listwrapper.scrollLeft + scrollStep;
		}

		this.animRef = requestAnimationFrame(() => {
			this._scroll();
		});
	}

	// _debounce(func, wait, immediate) {
	// 	let timeout;
	// 	return function() {
	// 		const context = this, args = arguments;
	// 		const later = () => {
	// 			timeout = null;
	// 			if (!immediate) func.apply(context, args);
	// 		};
	// 		const callNow = immediate && !timeout;
	// 		clearTimeout(timeout);
	// 		timeout = setTimeout(later, wait);
	// 		if (callNow) func.apply(context, args);
	// 	};
	// };

	show(index = 0, smoothing = true) {
		if (index > -1 && index < this.total) {
			this.currentIndex = index;
		} else {
			return;
		}
		console.log(index);

		this.previousButton.disabled = this.currentIndex === 0;
		this.nextButton.disabled = this.currentIndex === this.total - 1;
		this.container.dataset.currentIndex = this.currentIndex;

		if (smoothing) {
			if (!this.smoothScrollSupport) {
				if (this.animRef) {
					cancelAnimationFrame(this.animRef);
				}

				requestAnimationFrame(() => {
					this._scroll();
				});
			} else {
				if (this.listwrapper.scrollTo) {
					this.listwrapper.scrollTo({
						top: 0,
						left: this.currentIndex * this.container.offsetWidth,
						behavior: "smooth"
					});
				} else {
					console.log(this.currentIndex * this.container.offsetWidth);
					this.listwrapper.scrollLeft =
						this.currentIndex * this.container.offsetWidth;
				}
			}
		} else {
			this.listwrapper.scrollTo({
				top: 0,
				left: this.currentIndex * this.container.offsetWidth,
				behavior: "auto"
			});
		}

		return this;
	}

	open() {
		document.documentElement.style.overflow = "hidden";
		this.lastFocusedElement = document.activeElement;
		this.isOpen = true;
		this.container.style.visibility = "visible";
		this.container.dataset.isOpen = this.isOpen.toString();
		this.exitButton.focus();

		return this;
	}

	close() {
		document.documentElement.style.overflow = "";

		if (this.lastFocusedElement) {
			this.lastFocusedElement.focus();
		}

		this.isOpen = false;
		this.container.dataset.isOpen = this.isOpen.toString();
		this.container.removeAttribute("aria-activedescendant");

		return this;
	}
}
